import { createTheme, Theme } from '@mui/material'

export function getAppTheme (darkMode?: boolean): Theme {
  const customTheme = {
    typography: {
      h1: {
        textTransform: 'uppercase',
        fontSize: 30,
        color: '#1c7899',
        margin: '16px 0',
      },
      h2: {
        textTransform: 'uppercase',
        fontSize: 22,
        margin: '16px 0',
        fontWeight: 'bold',
      },
      subtitle1: {
        fontSize: 18,
        textTransform: 'uppercase',
        margin: '12px 0',
      },
      subtitle2: {
        fontSize: 18,
        fontWeight: 'bold',
        margin: '12px 0',
      },
      body1: {
        fontSize: 16,
        margin: '8px 0',
      },
    },
    palette: {
      primary: {
        main: '#6093a4',
        dark: '#1c7899',
        700: '#385763',
        800: '#2b434d',
        900: '#1e2f37',
      },
      secondary: {
        main: '#d1d1d1',
      },
      grey: {
        A700: '#616161',
      },
      background: {
        default: '#ebebeb',
        paper: '#ffffff',
      },
    },
    breakpoints: {
      values: {
        xs: 420,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  }

  const darkTheme = {
    typography: {
      h1: {
        textTransform: 'uppercase',
        fontSize: 30,
        color: '#6093a4',
        margin: '16px 0',
      },
      h2: {
        textTransform: 'uppercase',
        fontSize: 22,
        margin: '16px 0',
        fontWeight: 'bold',
      },
      subtitle1: {
        fontSize: 18,
        textTransform: 'uppercase',
        margin: '12px 0',
      },
      subtitle2: {
        fontSize: 18,
        fontWeight: 'bold',
        margin: '12px 0',
      },
      body1: {
        fontSize: 16,
        margin: '8px 0',
      },
      body2: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: 16,
        margin: '8px 0',
        fontWeight: 400,
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#81b4c7',
        dark: '#6093a4',
      },
      secondary: {
        main: '#d1d1d1',
      },
      background: {
        default: '#121212',
        paper: 'rgb(57,57,57)',
      },
      grey: {
        A700: '#393939',
      },
      text: {
        primary: 'rgba(255,255,255,0.79)',
        secondary: 'rgba(255,255,255,0.63)',
      },
    },
    breakpoints: {
      values: {
        xs: 420,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  }

  const theme: Theme = darkMode ? createTheme(darkTheme as Theme) : createTheme(customTheme as Theme)

  return theme
}
